import { createFileRoute } from "@tanstack/react-router";
import { ensureSourcingEnabled } from "@/features/sourcing/stage";
import { SearchPage } from "@/features/search/SearchPage";

export const Route = createFileRoute("/_auth/_agents/search")({
  beforeLoad: ({ context, preload }) => ensureSourcingEnabled(context.queryClient, preload),
  component: SearchPage,
});
